(() => {
  const init = () => {
    if (document.querySelector('[data-os-product],[data-os-collection]')) {
      document.querySelectorAll('form[action*="localization"] input[name="return_to"]').forEach(input => {input.value = location.pathname + location.search;});
    }
    document.querySelectorAll('[data-os-collection]').forEach(root => {
      if (root.dataset.osReady) return;
      root.dataset.osReady = 'true';
      const form = root.querySelector('#OsFilters');
      const dialog = root.querySelector('#OsFilterDialog');
      const home = root.querySelector('[data-os-filter-home]');
      const view = root.dataset.previewView;
      root.querySelectorAll('a').forEach(link => {
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || !/\/(products|collections)\//.test(url.pathname)) return;
        if (view) url.searchParams.set('view', view); else url.searchParams.delete('view');
        if (link.hasAttribute('data-os-filter-link') || link.closest('.os-pagination')) url.hash = 'OsCatalog';
        link.href = url.href;
      });
      const close = () => { if (dialog.open) dialog.close(); };
      root.querySelector('[data-os-open-filters]')?.addEventListener('click', () => {
        dialog.append(form);
        dialog.showModal();
        document.body.classList.add('os-filters-open');
      });
      form.querySelector('[data-os-close-filters]')?.addEventListener('click', close);
      dialog.addEventListener('close', () => {
        home.append(form);
        document.body.classList.remove('os-filters-open');
        root.querySelector('[data-os-open-filters]')?.focus();
      });
      dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); } });
      window.matchMedia('(min-width:750px)').addEventListener('change', e => { if (e.matches) close(); });
      root.querySelector('[data-os-sort]')?.addEventListener('change', () => form.requestSubmit());
      form.addEventListener('submit', e => {
        const min = form.querySelector('[name="filter.v.price.gte"]');
        const max = form.querySelector('[name="filter.v.price.lte"]');
        if (min && max) {
          max.setCustomValidity('');
          if (min.value && max.value && Number(min.value) > Number(max.value)) {
            e.preventDefault(); max.setCustomValidity(form.dataset.priceError); max.reportValidity(); return;
          }
        }
        form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) input.disabled = true; });
      });
      form.querySelectorAll('input[type="number"]').forEach(input => input.addEventListener('input', () => form.querySelectorAll('input[type="number"]').forEach(i => i.setCustomValidity(''))));
    });
    document.querySelectorAll('[data-os-product]').forEach(root => {
      if (root.dataset.osReady) return;
      root.dataset.osReady = 'true';
      const form = document.getElementById(root.dataset.formId);
      const sticky = root.querySelector('[data-os-product-sticky]');
      const button = form?.querySelector('[type="submit"][name="add"]');
      const stickyButton = sticky?.querySelector('button');
      if (!form || !button || !stickyButton) return;
      const sync = () => {
        stickyButton.disabled = button.disabled;
        const priceText = root.querySelector('.hdt-product__price .hdt-price .hdt-money')?.textContent.trim();
        if (priceText) sticky.querySelector('[data-os-sticky-price]').textContent = priceText;
      };
      new MutationObserver(sync).observe(root.querySelector('.os-product-info'), {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
      new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, {threshold:0}).observe(form);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
